import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { countries, devConfig, profile } from 'config/config'; // Importing configuration variables

/**
 * Class representing the FilterReferralsReportsView.
 * @extends JetView
 */
export default class FilterReferralsReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Input for Player ID
                            name: 'PlayerId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Referente'), // Label for Player ID
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Referente'), // Placeholder text
                        },
                        {
                            view: 'text', // Input for User ID
                            name: 'UserId',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-drivers-license-o'></span>" + _('ID Referido'), // Label for User ID
                            hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByUser',
                            labelPosition: 'top',
                            placeholder: _('ID Referido'), // Placeholder text
                        },
                        {
                            view: 'text', // Input for Registration Date
                            minWidth: 200,
                            name: 'DatepickerRegister',
                            id: 'DatepickerRegister',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Registro'), // Label for Registration Date
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            view: 'text', // Input for First Deposit Date
                            minWidth: 200,
                            name: 'DatepickerDeposit',
                            id: 'DatepickerDeposit',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Primer Deposito'), // Label for First Deposit Date
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for Country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            minWidth: 200,
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for Country selection
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: {
                                body: {
                                    template: function (obj) {
                                        return (
                                            "<i class='flags " + obj.icon + "'></i>" + obj.value // Template for displaying country flags
                                        );
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden: devConfig.getCountryReport() || !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Dropdown for State selection
                            name: 'State',
                            id: 'State',
                            label: _('Estado de Referido'), // Label for State selection
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                { id: 1, value: _('Activo') }, // Active state option
                                { id: 0, value: _('Inactivo') }, // Inactive state option
                            ],
                            value: 1, // Default value
                        },
                        {
                            view: 'radio', // Radio buttons for Type selection
                            name: 'Type',
                            id: 'Type',
                            label: _('Tipo'), // Label for Type selection
                            labelPosition: 'top',
                            minWidth: 200,
                            height: screen.width < 500 || screen.height < 500 ? 90 : 0, // Conditional height based on screen size
                            value: 1, // Default value
                            options: [
                                { id: 1, value: _('Totales') }, // Total option
                                { id: 0, value: _('Detallado') }, // Detailed option
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing filters
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'),
                    width: 140,
                    click: () => {
                        this.getRoot().clear(); // Clears the form
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'),
                    type: 'form',
                    width: 140,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        filterdata.Type = filterdata.Type.toString(); // Convert Type to string
                        if (filterdata.Type === '0' && filterdata.PlayerId === '') {
                            webix.message({
                                type: 'error',
                                text: _('El ID Referente es requerido'), // Error message for missing Player ID
                            });
                            return;
                        } else if (filterdata.Type === '') {
                            webix.message({
                                type: 'error',
                                text: _('El Tipo es requerido'), // Error message for missing Type
                            });
                            return;
                        }
                        this.app.callEvent('referralsReportPlayerMain:filter', [
                            filterdata, // Trigger event with filter data
                        ]);
                    },
                },
            ],
        };
        const accordion_section = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main form view
            type: 'clean',
            autofit: true,
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section // Show accordion section on larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and attaches events.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('DatepickerRegister').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal after rendering
        });
        $$('DatepickerDeposit').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal after rendering
        });
    }
}

// FILE DOCUMENTED
